<template>
  <div class="tasks-wrapper">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:map';
@use 'vuetify/lib/styles/settings/variables' as *;

.tasks-wrapper {
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: end;
  flex-direction: column;
  gap: 20px;
  z-index: 1005;
  justify-content: end;

  @media #{map.get($display-breakpoints, 'xs')} {
    bottom: 0;
    right: 0;

    &:has([data-expanded='true']) {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
